/**
 * Popup overview + about-banner Shopify Forms — Figma labels above fields.
 * Forces label-on-top + placeholders inside, people|city side-by-side.
 */
(function () {
  var CARD_SEL = '.amc-po--with-forms .amc-po__form-card, .amc-ab--with-form .amc-ab__form';
  var EMBED_SEL = 'form-embed, shopify-forms-embed';
  var STYLE_ATTR = 'data-amc-po-form-css';
  var AB_STYLE_ATTR = 'data-amc-ab-form-css';
  var LABELED_ATTR = 'data-amc-po-labeled';
  var SPLIT_ATTR = 'data-amc-po-split';
  var EIF_SPLIT_ATTR = 'data-amc-eif-split-row';
  var AB_ROOT_SEL = '.amc-ab--with-form';
  var running = false;
  var timer = null;

  var FIGMA_CSS =
    ':host, :root {' +
    '--forms-input-background-color: #fffbf0 !important;' +
    '--forms-field-background-color: #fffbf0 !important;' +
    '--forms-container-padding: 0 !important;' +
    '--forms-padding: 0 !important;' +
    'font-family: "DM Sans", "Plus Jakarta Sans", sans-serif !important;' +
    'margin: 0 !important; padding: 0 !important; display: block !important;' +
    '}' +
    '*, *::before, *::after { box-sizing: border-box !important; }' +
    'form, [data-testid="form-fields"], section[data-testid="form-container"], [class*="_formContainer_"], [class*="_inline_"] {' +
    'display: flex !important; flex-direction: column !important; gap: 16px !important; row-gap: 16px !important;' +
    'width: 100% !important; max-width: 100% !important;' +
    'margin: 0 !important; margin-block: 0 !important; padding: 0 !important; padding-block: 0 !important;' +
    'background: transparent !important; border: none !important; box-shadow: none !important; overflow: visible !important;' +
    'min-height: 0 !important;' +
    '}' +
    '[data-testid="form-header"], [data-testid="form-title"], [data-testid="form-description"],' +
    '[class*="FormHeader"], [class*="formHeader"], [class*="formAppTitle"], [class*="FormAppTitle"],' +
    '[class*="appTitle"], [class*="AppTitle"] {' +
    'display: none !important; height: 0 !important; min-height: 0 !important; max-height: 0 !important;' +
    'margin: 0 !important; padding: 0 !important; border: none !important; flex: 0 0 0 !important;' +
    'overflow: hidden !important; visibility: hidden !important; position: absolute !important;' +
    'width: 0 !important; pointer-events: none !important; gap: 0 !important;' +
    '}' +
    '[class*="disclaimer"], [class*="Disclaimer"], [class*="legalText"], [class*="LegalText"],' +
    '[data-testid="form-disclaimer"], [data-testid="marketing-consent"] {' +
    'display: none !important; height: 0 !important; min-height: 0 !important; max-height: 0 !important;' +
    'margin: 0 !important; padding: 0 !important; border: none !important; flex: 0 0 0 !important;' +
    'overflow: hidden !important; visibility: hidden !important;' +
    '}' +
    /* First field flush to top — kill leftover Forms chrome space */
    'form > *:first-child:empty,' +
    '[data-testid="form-fields"] > *:first-child:empty,' +
    'section[data-testid="form-container"] > *:first-child:empty {' +
    'display: none !important; height: 0 !important; margin: 0 !important; padding: 0 !important;' +
    '}' +
    '[class*="_formField_"]:first-child,' +
    '[class*="formField"]:first-child,' +
    '[data-testid="form-field"]:first-child,' +
    '[' +
    SPLIT_ATTR +
    ']:first-child,' +
    '[' +
    EIF_SPLIT_ATTR +
    ']:first-child {' +
    'margin-top: 0 !important; padding-top: 0 !important;' +
    '}' +
    'form,' +
    '[data-testid="form-fields"],' +
    'section[data-testid="form-container"],' +
    '[class*="_formContainer_"],' +
    '[class*="_inline_"] {' +
    'margin-top: 0 !important; padding-top: 0 !important;' +
    '}' +
    /* Keep people|city side-by-side even inside the narrow form card (override eif 989px stack). */
    '[' +
    SPLIT_ATTR +
    '], [' +
    EIF_SPLIT_ATTR +
    '] {' +
    'display: grid !important; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important; gap: 16px !important;' +
    'width: 100% !important; align-items: start !important; margin: 0 !important; padding: 0 !important;' +
    '}' +
    '[' +
    SPLIT_ATTR +
    '] > *, [' +
    EIF_SPLIT_ATTR +
    '] > * { min-width: 0 !important; width: 100% !important; max-width: 100% !important; }' +
    '@media screen and (max-width: 989px) {' +
    '[' +
    SPLIT_ATTR +
    '], [' +
    EIF_SPLIT_ATTR +
    '] {' +
    'grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important;' +
    '}' +
    '}' +
    '[class*="_formField_"]:not([class*="_formFieldset_"]),' +
    '[class*="formField"]:not([class*="formFieldset"]),' +
    '[data-testid="form-field"] {' +
    'display: flex !important; flex-direction: column !important; gap: 6px !important;' +
    'width: 100% !important; max-width: 100% !important; margin: 0 !important; padding: 0 !important;' +
    'background: transparent !important; border: none !important; box-shadow: none !important;' +
    'align-items: stretch !important;' +
    '}' +
    /* Only our top label is visible — hide Forms + eif duplicates */
    '.amc-po-form-label {' +
    'display: block !important; position: static !important; inset: auto !important; transform: none !important;' +
    'order: -1 !important; float: none !important; width: 100% !important; max-width: 100% !important;' +
    'margin: 0 !important; padding: 0 !important; height: auto !important; min-height: 0 !important;' +
    'font-family: "DM Sans", "Plus Jakarta Sans", sans-serif !important;' +
    'font-size: 16px !important; font-weight: 400 !important; line-height: 1.2 !important;' +
    'letter-spacing: 0.08px !important; color: #603338 !important;' +
    'background: transparent !important; border: none !important; box-shadow: none !important;' +
    'opacity: 1 !important; visibility: visible !important; clip: auto !important;' +
    'overflow: visible !important; white-space: normal !important; pointer-events: none !important;' +
    'z-index: auto !important;' +
    '}' +
    '[data-amc-po-labeled] label:not(.amc-po-form-label),' +
    '[data-amc-po-labeled] .amc-eif-form-label:not(.amc-po-form-label),' +
    '[data-amc-po-labeled] [class*="formInputFieldLabel"],' +
    '[data-amc-po-labeled] [class*="FieldLabel"],' +
    '[data-amc-po-label-hide] {' +
    'display: none !important; height: 0 !important; margin: 0 !important; padding: 0 !important;' +
    'overflow: hidden !important; visibility: hidden !important; opacity: 0 !important;' +
    'pointer-events: none !important; position: absolute !important; width: 0 !important;' +
    '}' +
    'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
    'textarea:not([name="h-captcha-response"]):not([id^="h-captcha-response"]),' +
    'select, button[role="combobox"], button[aria-haspopup="listbox"], [role="combobox"],' +
    '[class*="selectTrigger"], [class*="SelectTrigger"] {' +
    'width: 100% !important; max-width: 100% !important; min-height: 48px !important; height: 48px !important;' +
    'padding: 12px 16px !important; border: 1px solid #d5c1a5 !important; border-radius: 9999px !important;' +
    'background: #fffbf0 !important; color: #603338 !important;' +
    'font-family: "DM Sans", "Plus Jakarta Sans", sans-serif !important;' +
    'font-size: 16px !important; line-height: 1.3 !important; box-shadow: none !important;' +
    'appearance: none !important; -webkit-appearance: none !important;' +
    '}' +
    'input::placeholder, textarea::placeholder,' +
    '[class*="_formField_"] input::placeholder,' +
    '[class*="_formField_"] textarea::placeholder,' +
    '[data-amc-eif-has-top-label] input::placeholder,' +
    '[data-amc-eif-has-top-label] textarea::placeholder,' +
    '[data-amc-po-labeled] input::placeholder,' +
    '[data-amc-po-labeled] textarea::placeholder {' +
    'color: rgba(96,51,56,0.45) !important; opacity: 1 !important; -webkit-text-fill-color: rgba(96,51,56,0.45) !important;' +
    '}' +
    'button[type="submit"], [class*="formSubmit"], [class*="SubmitButton"], [data-testid="submit-button"] {' +
    'display: flex !important; align-items: center !important; justify-content: center !important;' +
    'width: 100% !important; max-width: 100% !important; min-width: 0 !important;' +
    'height: 56px !important; min-height: 56px !important; margin: 8px 0 0 !important; padding: 10px 24px !important;' +
    'border: none !important; border-radius: 9999px !important;' +
    'background: #603338 !important; color: #fff !important;' +
    'font-family: "DM Sans", "Plus Jakarta Sans", sans-serif !important;' +
    'font-size: 14px !important; font-weight: 500 !important; letter-spacing: 0.035px !important;' +
    'text-transform: uppercase !important; box-shadow: none !important; cursor: pointer !important;' +
    'overflow: visible !important;' +
    '}' +
    'textarea[name="h-captcha-response"], textarea[id^="h-captcha-response"] {' +
    'position: absolute !important; left: -9999px !important; width: 1px !important; height: 1px !important;' +
    'opacity: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important; border: none !important;' +
    '}' +
    'iframe[data-hcaptcha-widget-id] {' +
    'position: absolute !important; width: 1px !important; height: 1px !important; opacity: 0 !important; overflow: hidden !important;' +
    '}' +
    '[aria-invalid="true"], [class*="withError"] input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
    '[class*="_selectorError_"], [class*="selectContainer"]:has(output[role="alert"]) [class*="_selectToggle_"] {' +
    'border-color: #e02229 !important;' +
    '}' +
    'output[role="alert"], [class*="formError"], [class*="_formError_"] {' +
    'display: block !important; color: #e02229 !important; font-size: 13px !important; margin: 4px 0 0 !important;' +
    '}' +
    '[class*="formPhoneInputContainer"] output[role="alert"], [class*="PhoneInputContainer"] output[role="alert"] {' +
    'grid-column: 1 / -1 !important; width: 100% !important;' +
    '}' +
    '[class*="formPhoneInputContainer"]:has(output[role="alert"]), [class*="PhoneInputContainer"]:has(output[role="alert"]) {' +
    'border-color: #e02229 !important;' +
    '}' +
    '[data-testid="banner-success"], [data-amc-form-alert="success"],' +
    '[class*="formBannerContainer"]:not([data-testid="banner-warning"]),' +
    '[class*="successMessage"], [class*="SuccessMessage"], [data-testid="form-success"], [class*="formSuccess"] {' +
    'display: flex !important; flex-direction: column !important; align-items: flex-start !important;' +
    'justify-content: center !important; gap: 10px !important; box-sizing: border-box !important;' +
    'width: 100% !important; min-height: 180px !important; margin: 0 !important; padding: 28px 24px !important;' +
    'border: 1px solid #d5c1a5 !important; border-radius: 16px !important; background: #fffbf0 !important;' +
    'color: #603338 !important; visibility: visible !important; height: auto !important;' +
    'max-height: none !important; overflow: visible !important; position: static !important;' +
    'opacity: 1 !important; flex: none !important; pointer-events: auto !important;' +
    '}' +
    '[data-amc-form-alert="error"], [data-testid="banner-warning"] {' +
    'display: flex !important; flex-direction: column !important; align-items: flex-start !important;' +
    'gap: 4px !important; width: 100% !important; box-sizing: border-box !important;' +
    'min-height: 0 !important; max-height: none !important; margin: 0 0 4px !important; padding: 14px 16px !important;' +
    'border: 1px solid #e02229 !important; border-radius: 12px !important;' +
    'background: #fdf2f2 !important; color: #e02229 !important;' +
    'visibility: visible !important; height: auto !important; position: static !important; opacity: 1 !important;' +
    '}' +
    '[data-testid="banner-success"] h2, [data-amc-form-alert="success"] [class*="formBannerHeading"],' +
    '[data-amc-form-alert="success"] .amc-form-alert__title {' +
    'display: block !important; margin: 0 !important; font-size: 24px !important; line-height: 1.2 !important;' +
    'font-weight: 500 !important; color: #603338 !important; visibility: visible !important; height: auto !important;' +
    'text-align: left !important;' +
    '}' +
    '[data-testid="banner-success"] [class*="textBody"], [data-amc-form-alert="success"] .amc-form-alert__body {' +
    'display: block !important; margin: 0 !important; font-size: 16px !important; line-height: 1.45 !important;' +
    'color: #603338 !important; visibility: visible !important; height: auto !important;' +
    '}' +
    '[data-amc-form-alert="error"] .amc-form-alert__title { margin: 0 !important; font-size: 15px !important; font-weight: 500 !important; color: #e02229 !important; }' +
    '[data-amc-form-alert="error"] .amc-form-alert__body { margin: 0 !important; font-size: 14px !important; color: #e02229 !important; }' +
    '.amc-form-alert__icon { display: inline-flex !important; align-items: center !important; justify-content: center !important; width: 32px !important; height: 32px !important; border-radius: 999px !important; background: #603338 !important; color: #fffbf0 !important; }' +
    '[data-amc-form-alert="error"] .amc-form-alert__icon { background: #e02229 !important; color: #fff !important; }';

  function phoneLayoutCss(bg, border, labelGap) {
    return (
      '[data-amc-po-phone] {' +
      'display: flex !important; flex-direction: column !important; align-items: stretch !important;' +
      'width: 100% !important; max-width: 100% !important; min-width: 0 !important;' +
      'margin: 0 !important; padding: 0 !important; gap: ' +
      (labelGap || '6px') +
      ' !important;' +
      'background: transparent !important; border: none !important; box-shadow: none !important;' +
      '}' +
      '[class*="formPhoneInputContainer"], [class*="PhoneInputContainer"] {' +
      'display: flex !important; flex-direction: row !important; flex-wrap: nowrap !important;' +
      'align-items: stretch !important; justify-content: flex-start !important;' +
      'width: 100% !important; max-width: 100% !important; min-width: 0 !important;' +
      'min-height: 48px !important; height: 48px !important; max-height: 48px !important;' +
      'margin: 0 !important; padding: 0 !important; gap: 0 !important;' +
      'border: 1px solid ' +
      border +
      ' !important; border-radius: 9999px !important;' +
      'background: ' +
      bg +
      ' !important; box-shadow: none !important; overflow: visible !important;' +
      '}' +
      '[class*="formPhoneInputContainer"] > *, [class*="PhoneInputContainer"] > * {' +
      'min-width: 0 !important; height: 48px !important; max-height: 48px !important;' +
      'margin: 0 !important;' +
      '}' +
      '.phone-country-selector,' +
      '[class*="formPhoneInputContainer"] [class*="selectContainer"],' +
      '[class*="PhoneInputContainer"] [class*="selectContainer"] {' +
      'flex: 0 0 auto !important; width: auto !important; min-width: 72px !important;' +
      'height: 48px !important; max-height: 48px !important;' +
      'border: none !important; background: transparent !important; box-shadow: none !important;' +
      'border-radius: 0 !important; padding: 0 !important;' +
      '}' +
      '[class*="formPhoneInputContainer"] [class*="selectToggle"],' +
      '[class*="PhoneInputContainer"] [class*="selectToggle"],' +
      '.phone-country-selector button {' +
      'display: flex !important; align-items: center !important; justify-content: center !important;' +
      'box-sizing: border-box !important;' +
      'width: auto !important; min-width: 72px !important; max-width: none !important;' +
      'height: 48px !important; min-height: 48px !important; max-height: 48px !important;' +
      'margin: 0 !important; padding: 0 12px !important;' +
      'border: none !important; border-radius: 0 !important;' +
      'background: transparent !important; background-color: transparent !important;' +
      'box-shadow: none !important; flex: 0 0 auto !important; align-self: stretch !important;' +
      '}' +
      '[class*="formPhoneInputContainer"] [class*="formFieldContainer"],' +
      '[class*="PhoneInputContainer"] [class*="formFieldContainer"],' +
      '[class*="formPhoneInputContainer"] [class*="formField"]:not([class*="formFieldset"]) {' +
      'flex: 1 1 auto !important; min-width: 0 !important; width: auto !important; max-width: none !important;' +
      'display: flex !important; flex-direction: row !important; align-items: stretch !important;' +
      'gap: 0 !important; height: 48px !important; min-height: 48px !important; max-height: 48px !important;' +
      'padding: 0 !important; margin: 0 !important;' +
      'background: transparent !important; border: none !important; box-shadow: none !important;' +
      '}' +
      '[data-amc-po-phone] input[type="tel"]:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
      '[class*="formPhoneInputContainer"] input[type="tel"]:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
      '[class*="PhoneInputContainer"] input[type="tel"]:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
      'input[type="tel"][class*="formPhoneInputField"]:not([type="hidden"]) {' +
      'flex: 1 1 auto !important; width: 100% !important; min-width: 0 !important; max-width: 100% !important;' +
      'height: 48px !important; min-height: 48px !important; max-height: 48px !important;' +
      'margin: 0 !important; padding: 12px 16px 12px 8px !important;' +
      'border: none !important; border-width: 0 !important; border-color: transparent !important;' +
      'border-radius: 0 !important; outline: none !important;' +
      'background: transparent !important; background-color: transparent !important;' +
      'box-shadow: none !important;' +
      '}'
    );
  }

  FIGMA_CSS += phoneLayoutCss('#fffbf0', '#d5c1a5', '6px');

  /* About-banner terracotta (Figma 629:4186) — same layout, cream on terracotta */
  var AB_FIGMA_CSS =
    ':host, :root {' +
    '--forms-input-background-color: transparent !important;' +
    '--forms-field-background-color: transparent !important;' +
    '--forms-input-text-color: #f4f1e2 !important;' +
    '--forms-field-text-color: #f4f1e2 !important;' +
    '--forms-text-color: #f4f1e2 !important;' +
    '--forms-container-padding: 0 !important;' +
    '--forms-padding: 0 !important;' +
    'font-family: "DM Sans", "Plus Jakarta Sans", sans-serif !important;' +
    'color: #f4f1e2 !important;' +
    'margin: 0 !important; padding: 0 !important; display: block !important;' +
    '}' +
    '*, *::before, *::after { box-sizing: border-box !important; }' +
    'form, [data-testid="form-fields"], section[data-testid="form-container"], [class*="_formContainer_"], [class*="_inline_"] {' +
    'display: flex !important; flex-direction: column !important; gap: 16px !important; row-gap: 16px !important;' +
    'width: 100% !important; max-width: 100% !important;' +
    'margin: 0 !important; padding: 0 !important;' +
    'background: #af392b !important; border: none !important; box-shadow: none !important; overflow: visible !important;' +
    'align-items: stretch !important;' +
    '}' +
    '[data-testid="form-header"], [data-testid="form-title"], [data-testid="form-description"],' +
    '[class*="FormHeader"], [class*="formHeader"], [class*="formAppTitle"], [class*="FormAppTitle"],' +
    '[class*="appTitle"], [class*="AppTitle"],' +
    '[class*="disclaimer"], [class*="Disclaimer"], [class*="legalText"], [class*="LegalText"],' +
    '[data-testid="form-disclaimer"], [data-testid="marketing-consent"] {' +
    'display: none !important; height: 0 !important; margin: 0 !important; padding: 0 !important;' +
    'overflow: hidden !important; visibility: hidden !important; border: none !important;' +
    '}' +
    '[' +
    SPLIT_ATTR +
    '], [' +
    EIF_SPLIT_ATTR +
    '] {' +
    'display: grid !important; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) !important; gap: 16px !important;' +
    'width: 100% !important; align-items: start !important; margin: 0 !important; padding: 0 !important;' +
    '}' +
    '[' +
    SPLIT_ATTR +
    '] > *, [' +
    EIF_SPLIT_ATTR +
    '] > * { min-width: 0 !important; width: 100% !important; max-width: 100% !important; }' +
    '[class*="_formField_"]:not([class*="_formFieldset_"]),' +
    '[class*="formField"]:not([class*="formFieldset"]),' +
    '[data-testid="form-field"] {' +
    'display: flex !important; flex-direction: column !important; gap: 12px !important;' +
    'width: 100% !important; max-width: 100% !important; margin: 0 !important; padding: 0 !important;' +
    'background: transparent !important; border: none !important; box-shadow: none !important;' +
    'align-items: stretch !important; overflow: visible !important;' +
    '}' +
    'label, [class*="formInputFieldLabel"], [class*="FieldLabel"] {' +
    'color: #fffbf0 !important; opacity: 1 !important; -webkit-text-fill-color: #fffbf0 !important;' +
    '}' +
    '.amc-po-form-label {' +
    'display: block !important; position: static !important; inset: auto !important; transform: none !important;' +
    'order: -1 !important; width: 100% !important; margin: 0 !important; padding: 0 !important;' +
    'font-family: "DM Sans", "Plus Jakarta Sans", sans-serif !important;' +
    'font-size: 16px !important; font-weight: 400 !important; line-height: 1.2 !important;' +
    'letter-spacing: 0.08px !important; color: #fffbf0 !important; -webkit-text-fill-color: #fffbf0 !important;' +
    'background: transparent !important; border: none !important; opacity: 1 !important;' +
    'visibility: visible !important; overflow: visible !important; pointer-events: none !important;' +
    '}' +
    '[data-amc-po-labeled] label:not(.amc-po-form-label),' +
    '[data-amc-po-labeled] .amc-eif-form-label:not(.amc-po-form-label),' +
    '[data-amc-po-labeled] [class*="formInputFieldLabel"],' +
    '[data-amc-po-labeled] [class*="FieldLabel"],' +
    '[data-amc-po-label-hide] {' +
    'display: none !important; height: 0 !important; margin: 0 !important; padding: 0 !important;' +
    'overflow: hidden !important; visibility: hidden !important; opacity: 0 !important;' +
    'pointer-events: none !important; position: absolute !important; width: 0 !important;' +
    '}' +
    'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
    'textarea:not([name="h-captcha-response"]):not([id^="h-captcha-response"]),' +
    'select, button[role="combobox"], button[aria-haspopup="listbox"], [role="combobox"],' +
    '[class*="selectTrigger"], [class*="SelectTrigger"] {' +
    'width: 100% !important; max-width: 100% !important; min-height: 48px !important; height: 48px !important;' +
    'padding: 12px 16px !important; border: 1px solid #d5c1a5 !important; border-radius: 9999px !important;' +
    'background: transparent !important; color: #f4f1e2 !important;' +
    '-webkit-text-fill-color: #f4f1e2 !important; caret-color: #f4f1e2 !important;' +
    'font-family: "DM Sans", "Plus Jakarta Sans", sans-serif !important;' +
    'font-size: 16px !important; line-height: 1.3 !important; box-shadow: none !important;' +
    'appearance: none !important; -webkit-appearance: none !important;' +
    '}' +
    'input::placeholder, textarea::placeholder {' +
    'color: rgba(244,241,226,0.5) !important; opacity: 1 !important;' +
    '-webkit-text-fill-color: rgba(244,241,226,0.5) !important;' +
    '}' +
    'input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus,' +
    'textarea:-webkit-autofill, select:-webkit-autofill {' +
    '-webkit-text-fill-color: #f4f1e2 !important; caret-color: #f4f1e2 !important;' +
    'box-shadow: 0 0 0 1000px transparent inset !important;' +
    'transition: background-color 99999s ease-out !important;' +
    '}' +
    'div:has(> button[type="submit"]),' +
    '[class*="formSubmit"],' +
    '[class*="SubmitButton"],' +
    '[data-testid="submit-button"] {' +
    'display: flex !important; align-items: center !important; justify-content: flex-start !important;' +
    'width: auto !important; max-width: 100% !important; margin: 16px 0 0 !important; padding: 0 !important;' +
    'background: transparent !important; border: none !important; box-shadow: none !important;' +
    'overflow: visible !important; align-self: flex-start !important; flex: 0 0 auto !important;' +
    '}' +
    'button[type="submit"], [class*="formSubmit"] button, [class*="SubmitButton"] button,' +
    '[data-testid="submit-button"] button, button[data-testid="submit-button"] {' +
    'display: inline-flex !important; align-items: center !important; justify-content: center !important;' +
    'box-sizing: border-box !important;' +
    'width: auto !important; min-width: 245px !important; max-width: 100% !important;' +
    'height: 56px !important; min-height: 56px !important; margin: 0 !important; padding: 10px 48px !important;' +
    'border: none !important; border-radius: 9999px !important;' +
    'background: #ffffff !important; color: #603338 !important;' +
    'font-family: "DM Sans", "Plus Jakarta Sans", sans-serif !important;' +
    'font-size: 14px !important; font-weight: 400 !important; letter-spacing: 0.035px !important;' +
    'text-transform: uppercase !important; box-shadow: none !important; cursor: pointer !important;' +
    'overflow: visible !important; align-self: flex-start !important; flex: 0 0 auto !important;' +
    'white-space: nowrap !important;' +
    '}' +
    'textarea[name="h-captcha-response"], textarea[id^="h-captcha-response"] {' +
    'position: absolute !important; left: -9999px !important; width: 1px !important; height: 1px !important;' +
    'opacity: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important; border: none !important;' +
    '}' +
    'iframe[data-hcaptcha-widget-id] {' +
    'position: absolute !important; width: 1px !important; height: 1px !important; opacity: 0 !important; overflow: hidden !important;' +
    '}' +
    '[aria-invalid="true"], [class*="withError"] input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
    '[class*="_selectorError_"], [class*="selectContainer"]:has(output[role="alert"]) [class*="_selectToggle_"] {' +
    'border-color: #e02229 !important;' +
    '}' +
    'output[role="alert"], [class*="formError"], [class*="_formError_"] {' +
    'display: block !important; color: #e02229 !important; font-size: 13px !important; margin: 4px 0 0 !important;' +
    '}' +
    '[class*="formPhoneInputContainer"] output[role="alert"], [class*="PhoneInputContainer"] output[role="alert"] {' +
    'grid-column: 1 / -1 !important; width: 100% !important;' +
    '}' +
    '[class*="formPhoneInputContainer"]:has(output[role="alert"]), [class*="PhoneInputContainer"]:has(output[role="alert"]) {' +
    'border-color: #e02229 !important;' +
    '}' +
    '[data-testid="banner-success"], [data-amc-form-alert="success"],' +
    '[class*="formBannerContainer"]:not([data-testid="banner-warning"]),' +
    '[class*="successMessage"], [class*="SuccessMessage"], [data-testid="form-success"], [class*="formSuccess"] {' +
    'display: flex !important; flex-direction: column !important; align-items: flex-start !important;' +
    'justify-content: center !important; gap: 10px !important; box-sizing: border-box !important;' +
    'width: 100% !important; min-height: 180px !important; margin: 0 !important; padding: 28px 24px !important;' +
    'border: 1px solid #fffbf0 !important; border-radius: 16px !important; background: #fffbf0 !important;' +
    'color: #603338 !important; visibility: visible !important; height: auto !important;' +
    'max-height: none !important; overflow: visible !important; position: static !important;' +
    'opacity: 1 !important; flex: none !important; pointer-events: auto !important;' +
    '}' +
    '[data-amc-form-alert="error"], [data-testid="banner-warning"] {' +
    'display: flex !important; flex-direction: column !important; align-items: flex-start !important;' +
    'gap: 4px !important; width: 100% !important; box-sizing: border-box !important;' +
    'min-height: 0 !important; max-height: none !important; margin: 0 0 4px !important; padding: 14px 16px !important;' +
    'border: 1px solid #fffbf0 !important; border-radius: 12px !important;' +
    'background: #fffbf0 !important; color: #e02229 !important;' +
    'visibility: visible !important; height: auto !important; position: static !important; opacity: 1 !important;' +
    '}' +
    '[data-testid="banner-success"] h2, [data-amc-form-alert="success"] [class*="formBannerHeading"],' +
    '[data-amc-form-alert="success"] .amc-form-alert__title {' +
    'display: block !important; margin: 0 !important; font-size: 24px !important; line-height: 1.2 !important;' +
    'font-weight: 500 !important; color: #603338 !important; visibility: visible !important; height: auto !important;' +
    'text-align: left !important;' +
    '}' +
    '[data-testid="banner-success"] [class*="textBody"], [data-amc-form-alert="success"] .amc-form-alert__body {' +
    'display: block !important; margin: 0 !important; font-size: 16px !important; line-height: 1.45 !important;' +
    'color: #603338 !important; visibility: visible !important; height: auto !important;' +
    '}' +
    '[data-amc-form-alert="error"] .amc-form-alert__title { margin: 0 !important; font-size: 15px !important; font-weight: 500 !important; color: #e02229 !important; }' +
    '[data-amc-form-alert="error"] .amc-form-alert__body { margin: 0 !important; font-size: 14px !important; color: #e02229 !important; }' +
    '.amc-form-alert__icon { display: inline-flex !important; align-items: center !important; justify-content: center !important; width: 32px !important; height: 32px !important; border-radius: 999px !important; background: #603338 !important; color: #fffbf0 !important; }' +
    '[data-amc-form-alert="error"] .amc-form-alert__icon { background: #e02229 !important; color: #fff !important; }';

  AB_FIGMA_CSS += phoneLayoutCss('transparent', '#d5c1a5', '12px');

  var LABEL_MAP = {
    'your full name': { label: 'Your Name*', placeholder: 'Your full name' },
    'your name': { label: 'Your Name*', placeholder: 'Your full name' },
    name: { label: 'Your Name*', placeholder: 'Your full name' },
    'first name': { label: 'Your Name*', placeholder: 'Your full name' },
    firstname: { label: 'Your Name*', placeholder: 'Your full name' },
    'given name': { label: 'Your Name*', placeholder: 'Your full name' },
    'given-name': { label: 'Your Name*', placeholder: 'Your full name' },
    email: { label: 'Email*', placeholder: 'Your email address' },
    'your email address': { label: 'Email*', placeholder: 'Your email address' },
    'your email': { label: 'Email*', placeholder: 'Your email address' },
    'how many people are joining?': {
      label: 'How many people are joining?*',
      placeholder: '10-15 people'
    },
    'how many people are joining': {
      label: 'How many people are joining?*',
      placeholder: '10-15 people'
    },
    'how many people': {
      label: 'How many people are joining?*',
      placeholder: '10-15 people'
    },
    '10-15 people': {
      label: 'How many people are joining?*',
      placeholder: '10-15 people'
    },
    '1-15 people': {
      label: 'How many people are joining?*',
      placeholder: '10-15 people'
    },
    city: { label: 'City*', placeholder: 'Please select...' },
    'city?': { label: 'City*', placeholder: 'Please select...' },
    location: { label: 'City*', placeholder: 'Please select...' },
    'location?': { label: 'City*', placeholder: 'Please select...' },
    'please select...': { label: 'City*', placeholder: 'Please select...' },
    'please select': { label: 'City*', placeholder: 'Please select...' },
    phone: { label: 'Phone', placeholder: '' },
    'phone number': { label: 'Phone', placeholder: '' },
    phonenumber: { label: 'Phone', placeholder: '' },
    tel: { label: 'Phone', placeholder: '' }
  };

  function norm(value) {
    return String(value || '')
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function fieldContainers(scope) {
    var sels = [
      '[class*="_formField_"]',
      '[class*="formField"]',
      '[data-testid="form-field"]'
    ];
    var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
    var out = [];
    sels.forEach(function (sel) {
      scope.querySelectorAll(sel).forEach(function (node) {
        var cls = String(node.className || '');
        if (cls.indexOf('_formFieldset_') !== -1 || cls.indexOf('formFieldset') !== -1) return;
        if (node.querySelector('input[type="radio"]')) return;
        if (!controlOf(node)) return;
        if (seen) {
          if (seen.has(node)) return;
          seen.add(node);
        } else if (out.indexOf(node) !== -1) {
          return;
        }
        out.push(node);
      });
    });
    return out;
  }

  function controlOf(container) {
    var tel = container.querySelector('input[type="tel"]:not([type="hidden"])');
    if (tel) return tel;
    return container.querySelector(
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), textarea:not([name="h-captcha-response"]), select, button[role="combobox"], button[aria-haspopup="listbox"]'
    );
  }

  function rawHints(container) {
    var bits = [];
    container
      .querySelectorAll(
        ':scope > .amc-po-form-label, :scope > .amc-eif-form-label, :scope > label, :scope > [class*="formInputFieldLabel"], :scope > [class*="FieldLabel"]'
      )
      .forEach(function (el) {
        var t = (el.textContent || '').trim();
        if (t) bits.push(t);
      });
    var field = controlOf(container);
    if (field) {
      bits.push(field.getAttribute('aria-label') || '');
      bits.push(field.getAttribute('placeholder') || '');
      bits.push(field.getAttribute('name') || '');
      bits.push(field.getAttribute('autocomplete') || '');
      bits.push(field.getAttribute('type') || '');
    }
    return bits.filter(Boolean);
  }

  function resolveMap(container) {
    var hints = rawHints(container);
    for (var i = 0; i < hints.length; i++) {
      var key = norm(hints[i]);
      if (LABEL_MAP[key]) return LABEL_MAP[key];
    }
    if (container.querySelector('input[type="tel"]')) return LABEL_MAP.phone;
    for (var j = 0; j < hints.length; j++) {
      var h = norm(hints[j]);
      if (h.indexOf('email') !== -1) return LABEL_MAP.email;
      if (h.indexOf('city') !== -1 || h.indexOf('location') !== -1) return LABEL_MAP.city;
      if (h.indexOf('people') !== -1 || h.indexOf('joining') !== -1) return LABEL_MAP['how many people'];
      if (h.indexOf('phone') !== -1 || h === 'tel') return LABEL_MAP.phone;
      if (
        h === 'name' ||
        h.indexOf('first name') !== -1 ||
        h.indexOf('full name') !== -1 ||
        h.indexOf('your name') !== -1 ||
        h === 'given-name' ||
        h === 'firstname'
      ) {
        return LABEL_MAP.name;
      }
    }
    return null;
  }

  var AB_CREAM = '#f4f1e2';
  var AB_BORDER = '#d5c1a5';
  var AB_FIELD_SEL =
    'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]),' +
    'textarea:not([name="h-captcha-response"]):not([id^="h-captcha-response"]),' +
    'select,' +
    'button[role="combobox"],' +
    'button[aria-haspopup="listbox"],' +
    '[role="combobox"],' +
    '[class*="selectTrigger"],' +
    '[class*="SelectTrigger"]';

  function isAboutBanner(hostEl) {
    return !!(hostEl && hostEl.closest && hostEl.closest(AB_ROOT_SEL));
  }

  function fieldHasError(el) {
    if (!el) return false;
    if (el.getAttribute && el.getAttribute('aria-invalid') === 'true') return true;
    if (el.closest && el.closest('[class*="withError"], [class*="_selectorError_"]')) return true;
    var wrap =
      el.closest &&
      el.closest(
        '[class*="selectContainer"], [class*="formField"], [class*="_formField_"], [class*="formPhoneInputContainer"], [class*="PhoneInputContainer"]'
      );
    return !!(wrap && wrap.querySelector && wrap.querySelector('output[role="alert"]'));
  }

  /* Beat Shopify Forms default white pills + other formStyles (#603338) for about-banner only. */
  function applyAboutCreamText(scope, hostEl) {
    if (!scope || !isAboutBanner(hostEl)) return;

    var formHost = null;
    if (scope instanceof ShadowRoot && scope.host) {
      formHost = scope.host;
    } else if (hostEl && hostEl.matches) {
      if (hostEl.matches(EMBED_SEL) || hostEl.hasAttribute('data-forms-id')) {
        formHost = hostEl;
      }
    }

    if (formHost && formHost.style && formHost.style.setProperty) {
      formHost.style.setProperty('--forms-input-background-color', 'transparent');
      formHost.style.setProperty('--forms-field-background-color', 'transparent');
      formHost.style.setProperty('--forms-input-text-color', AB_CREAM);
      formHost.style.setProperty('--forms-field-text-color', AB_CREAM);
      formHost.style.setProperty('--forms-text-color', AB_CREAM);
      formHost.style.setProperty('color', AB_CREAM);
    }

    if (!scope.querySelectorAll) return;
    scope
      .querySelectorAll('label, [class*="formInputFieldLabel"], [class*="FieldLabel"], .amc-po-form-label')
      .forEach(function (label) {
        if (!label || !label.style || !label.style.setProperty) return;
        if (label.hasAttribute('data-amc-po-label-hide')) return;
        label.style.setProperty('color', '#fffbf0', 'important');
        label.style.setProperty('-webkit-text-fill-color', '#fffbf0', 'important');
        label.style.setProperty('opacity', '1', 'important');
      });
    nameFormA11y(scope);
    var fields = scope.querySelectorAll(AB_FIELD_SEL);
    if (!fields.length) return;

    fields.forEach(function (el) {
      if (!el || !el.style || !el.style.setProperty) return;
      if (el.type === 'submit' || el.getAttribute('type') === 'submit') return;
      el.style.setProperty('background', 'transparent', 'important');
      el.style.setProperty('background-color', 'transparent', 'important');
      el.style.setProperty('border-radius', '9999px', 'important');
      el.style.setProperty('box-shadow', 'none', 'important');
      el.style.setProperty('color', AB_CREAM, 'important');
      el.style.setProperty('-webkit-text-fill-color', AB_CREAM, 'important');
      el.style.setProperty('caret-color', AB_CREAM, 'important');
    });

    scope
      .querySelectorAll(
        '[class*="textField"], [class*="TextField"], [class*="inputWrapper"], [class*="InputWrapper"], [class*="selectField"], [class*="SelectField"]'
      )
      .forEach(function (wrap) {
        if (!wrap || !wrap.style || !wrap.style.setProperty) return;
        wrap.style.setProperty('background', 'transparent', 'important');
        wrap.style.setProperty('background-color', 'transparent', 'important');
        wrap.style.setProperty('box-shadow', 'none', 'important');
        wrap.style.setProperty('border', 'none', 'important');
      });
  }

  function injectCss(root, hostEl) {
    if (!root || !root.appendChild) return;
    // Light-DOM <style> is not scoped by its parent. Bare `form` / `input`
    // selectors leak sitewide and break other UI (e.g. .amc-eh__search row pill).
    if (!(root instanceof ShadowRoot)) return;
    var about = isAboutBanner(hostEl);
    var attr = about ? AB_STYLE_ATTR : STYLE_ATTR;
    var css = about ? AB_FIGMA_CSS : FIGMA_CSS;
    var style = root.querySelector && root.querySelector('style[' + attr + ']');
    if (!style) {
      style = document.createElement('style');
      style.setAttribute(attr, '');
    }
    style.textContent = css;
    root.appendChild(style);
  }

  function phoneShellOf(container) {
    var cur = container;
    while (cur && cur.nodeType === 1) {
      var cls = String(cur.className || '');
      if (cls.indexOf('formPhoneInputContainer') !== -1 || cls.indexOf('PhoneInputContainer') !== -1) {
        return cur;
      }
      cur = cur.parentElement;
    }
    return null;
  }

  function phoneWrapOf(container) {
    var cur = container;
    while (cur && cur.nodeType === 1) {
      if (cur.hasAttribute && cur.hasAttribute('data-amc-po-phone')) return cur;
      cur = cur.parentElement;
    }
    return null;
  }

  function hoistPhoneLabel(container, top) {
    if (!container || !top) return top;
    if (!container.querySelector('input[type="tel"]')) return top;

    var wrap = phoneWrapOf(container);
    if (wrap) {
      if (top.parentElement !== wrap) wrap.insertBefore(top, wrap.firstChild);
      else if (wrap.firstElementChild !== top) wrap.insertBefore(top, wrap.firstChild);
      return top;
    }

    var shell = phoneShellOf(container);
    if (!shell || !shell.parentNode) return top;

    wrap = document.createElement('div');
    wrap.setAttribute('data-amc-po-phone', '');
    shell.parentNode.insertBefore(wrap, shell);
    wrap.appendChild(top);
    wrap.appendChild(shell);
    return top;
  }

  function hideForeignLabels(container, keep) {
    if (!container || !keep) return;
    container
      .querySelectorAll('label, .amc-eif-form-label, [class*="formInputFieldLabel"], [class*="FieldLabel"]')
      .forEach(function (el) {
        if (el === keep) return;
        if (keep.contains(el)) return;
        el.setAttribute('data-amc-po-label-hide', '');
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('height', '0', 'important');
        el.style.setProperty('margin', '0', 'important');
        el.style.setProperty('padding', '0', 'important');
        el.style.setProperty('overflow', 'hidden', 'important');
      });
  }

  function applyLabels(scope) {
    fieldContainers(scope).forEach(function (container) {
      var field = controlOf(container);
      if (!field) return;
      var mapped = resolveMap(container);
      var labelText = mapped ? mapped.label : '';
      var placeholder = mapped ? mapped.placeholder : '';
      if (!labelText) {
        var hints = rawHints(container);
        labelText = hints[0] || '';
      }
      if (!labelText) return;

      var wrap = phoneWrapOf(container);
      var top =
        (wrap && wrap.querySelector(':scope > .amc-po-form-label')) ||
        container.querySelector(':scope > .amc-po-form-label') ||
        container.querySelector(':scope > .amc-eif-form-label');
      if (!top) {
        top = document.createElement('label');
        top.className = 'amc-po-form-label';
        container.insertBefore(top, container.firstElementChild);
      } else {
        top.className = 'amc-po-form-label';
        top.removeAttribute('data-amc-po-label-hide');
        top.style.removeProperty('display');
        top.style.removeProperty('visibility');
        top.style.removeProperty('height');
        top.style.removeProperty('margin');
        top.style.removeProperty('padding');
        top.style.removeProperty('overflow');
      }
      top.textContent = labelText;
      if (field.id) top.setAttribute('for', field.id);
      field.setAttribute('aria-label', labelText);
      if (
        placeholder &&
        (field.tagName === 'INPUT' || field.tagName === 'TEXTAREA') &&
        field.getAttribute('type') !== 'tel'
      ) {
        field.setAttribute('placeholder', placeholder);
      }
      container.setAttribute(LABELED_ATTR, '');
      container.setAttribute('data-amc-eif-has-top-label', '');
      hoistPhoneLabel(container, top);
      hideForeignLabels(container, top);
    });
  }

  function kindOf(container) {
    var mapped = resolveMap(container);
    var t = mapped ? norm(mapped.label) : norm((rawHints(container) || []).join(' '));
    if (t.indexOf('how many') !== -1 || t.indexOf('people') !== -1 || t.indexOf('joining') !== -1) {
      return 'people';
    }
    if (t.indexOf('email') !== -1) return 'email';
    if (t.indexOf('city') !== -1 || t.indexOf('location') !== -1) return 'city';
    if (t.indexOf('name') !== -1) return 'name';
    return '';
  }

  function markSplitRow(row) {
    row.setAttribute(SPLIT_ATTR, '');
    row.setAttribute(EIF_SPLIT_ATTR, '');
  }

  function split(scope) {
    var people = null;
    var email = null;
    var city = null;
    fieldContainers(scope).forEach(function (container) {
      var kind = kindOf(container);
      if (kind === 'people' && !people) people = container;
      if (kind === 'email' && !email) email = container;
      if (kind === 'city' && !city) city = container;
    });
    if (!city) return;

    var left = people || email;
    if (!left) return;

    var existing = left.parentElement;
    if (
      existing &&
      (existing.hasAttribute(SPLIT_ATTR) || existing.hasAttribute(EIF_SPLIT_ATTR))
    ) {
      markSplitRow(existing);
      if (city.parentElement !== existing) existing.appendChild(city);
      return;
    }

    var root =
      left.closest('[data-testid="form-fields"]') ||
      left.closest('form') ||
      left.parentElement;
    if (!root) return;

    var row = document.createElement('div');
    markSplitRow(row);
    root.insertBefore(row, left);
    row.appendChild(left);
    row.appendChild(city);
  }

  function collapseChrome(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope
      .querySelectorAll(
        '[data-testid="form-header"], [data-testid="form-title"], [data-testid="form-description"], [class*="FormHeader"], [class*="formHeader"], [class*="formAppTitle"], [class*="FormAppTitle"]'
      )
      .forEach(function (el) {
        if (
          el.closest &&
          el.closest(
            '[data-amc-form-alert], [data-testid="banner-success"], [data-testid="banner-warning"], [class*="formBannerContainer"], [data-current-step="success"], [class*="successMessage"], [class*="SuccessMessage"], [data-testid="form-success"]'
          )
        ) {
          return;
        }
        var text = String(el.textContent || '').toLowerCase();
        if (
          text.indexOf('thank you') !== -1 ||
          text.indexOf('success') !== -1 ||
          text.indexOf('submitted') !== -1 ||
          text.indexOf('enquiry sent') !== -1 ||
          text.indexOf("you're on the list") !== -1 ||
          text.indexOf("we'll notify") !== -1 ||
          text.indexOf("we'll be in touch") !== -1
        ) {
          return;
        }
        if (el.parentNode) el.parentNode.removeChild(el);
      });
  }

  function fixSubmit(scope, hostEl) {
    if (!scope || !scope.querySelectorAll || !isAboutBanner(hostEl)) return;
    scope
      .querySelectorAll(
        'button[type="submit"], [data-testid="submit-button"], [class*="formSubmit"] button, [class*="SubmitButton"] button, button[class*="formSubmit"], button[class*="SubmitButton"]'
      )
      .forEach(function (btn) {
        if (!btn || btn.tagName !== 'BUTTON') return;
        var text = String(btn.textContent || '')
          .replace(/\s+/g, ' ')
          .trim()
          .toUpperCase();
        if (!text || text === 'SUBMIT' || text === 'SEND' || text === 'SEND MESSAGE') {
          btn.textContent = 'TAKE A SEAT';
        }
        /* Beat Shopify Forms formStyles width:100% — match Figma/ss2 pill */
        btn.style.setProperty('display', 'inline-flex', 'important');
        btn.style.setProperty('align-items', 'center', 'important');
        btn.style.setProperty('justify-content', 'center', 'important');
        btn.style.setProperty('box-sizing', 'border-box', 'important');
        btn.style.setProperty('width', '245px', 'important');
        btn.style.setProperty('min-width', '245px', 'important');
        btn.style.setProperty('max-width', '100%', 'important');
        btn.style.setProperty('height', '56px', 'important');
        btn.style.setProperty('min-height', '56px', 'important');
        btn.style.setProperty('padding', '10px 48px', 'important');
        btn.style.setProperty('margin', '16px 0 0', 'important');
        btn.style.setProperty('border', 'none', 'important');
        btn.style.setProperty('border-radius', '9999px', 'important');
        btn.style.setProperty('background', '#ffffff', 'important');
        btn.style.setProperty('background-color', '#ffffff', 'important');
        btn.style.setProperty('color', '#603338', 'important');
        btn.style.setProperty('font-size', '14px', 'important');
        btn.style.setProperty('font-weight', '400', 'important');
        btn.style.setProperty('letter-spacing', '0.035px', 'important');
        btn.style.setProperty('text-transform', 'uppercase', 'important');
        btn.style.setProperty('align-self', 'flex-start', 'important');
        btn.style.setProperty('flex', '0 0 auto', 'important');
        btn.style.setProperty('overflow', 'visible', 'important');
        btn.style.setProperty('white-space', 'nowrap', 'important');
        btn.style.setProperty('cursor', 'pointer', 'important');

        var wrap = btn.parentElement;
        if (wrap && wrap !== scope) {
          wrap.style.setProperty('width', 'auto', 'important');
          wrap.style.setProperty('max-width', '100%', 'important');
          wrap.style.setProperty('align-self', 'flex-start', 'important');
          wrap.style.setProperty('overflow', 'visible', 'important');
          wrap.style.setProperty('background', 'transparent', 'important');
          wrap.style.setProperty('display', 'flex', 'important');
          wrap.style.setProperty('justify-content', 'flex-start', 'important');
        }
      });
  }

  function nameFormA11y(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[role="dialog"], [role="alertdialog"]').forEach(function (el) {
      if (el.getAttribute('aria-label') || el.getAttribute('aria-labelledby')) return;
      var heading = el.querySelector('h1, h2, h3, h4, h5, h6, [data-testid="form-title"]');
      if (heading && String(heading.textContent || '').trim()) {
        if (!heading.id) heading.id = 'amc-form-title-' + Math.random().toString(36).slice(2, 9);
        el.setAttribute('aria-labelledby', heading.id);
      } else {
        el.setAttribute('aria-label', 'Workshop inquiry form');
      }
    });
    scope.querySelectorAll('h4').forEach(function (h4) {
      if (!h4.parentNode) return;
      var h3 = document.createElement('h3');
      Array.prototype.forEach.call(h4.attributes, function (attr) {
        h3.setAttribute(attr.name, attr.value);
      });
      while (h4.firstChild) h3.appendChild(h4.firstChild);
      h4.parentNode.replaceChild(h3, h4);
    });
  }

  function processScope(scope, hostEl) {
    if (!scope) return;
    injectCss(scope, hostEl);
    applyAboutCreamText(scope, hostEl);
    collapseChrome(scope);
    nameFormA11y(scope);
    applyLabels(scope);
    split(scope);
    fixSubmit(scope, hostEl);
  }

  function walkShadows(root, visit, hostEl) {
    if (!root) return;
    visit(root, hostEl);
    var nodes = root.querySelectorAll ? root.querySelectorAll('*') : [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].shadowRoot) walkShadows(nodes[i].shadowRoot, visit, hostEl);
    }
  }

  var watchedShadows = [];

  function watchShadow(shadowRoot) {
    if (!shadowRoot) return;
    for (var i = 0; i < watchedShadows.length; i++) {
      if (watchedShadows[i] === shadowRoot) return;
    }
    watchedShadows.push(shadowRoot);
    new MutationObserver(schedule).observe(shadowRoot, { childList: true, subtree: true });
  }

  function processAogenPoForms() {
    var PLACEHOLDERS = {
      name: 'Your full name',
      email: 'Your email address',
      phone: 'Your phone number',
      how_many_people_are_joining: '10-15 people',
      city: 'City',
      city_2: 'City',
      event_type: 'What are you planning?',
      preferred_date: 'dd/mm/yyyy',
      location: 'Please select...',
      enter_number_of_guests_minimum_8_required: '8+',
      company_name: 'Company name',
      budget: 'Select a range',
      questions_and_notes: 'Anything we should know?'
    };
    var LABELS = {
      name: 'Your Name*',
      email: 'Email*',
      phone: 'Phone',
      how_many_people_are_joining: 'How many people are joining?*',
      city_2: 'City*',
      city: 'City*'
    };

    document
      .querySelectorAll(
        '.amc-po__form-card-body .aogen-forms-form, .amc-eif__form .aogen-forms-form, .amc-ab__form .aogen-forms-form'
      )
      .forEach(function (form) {
      var card = form.closest('.amc-po__form-card');
      var inPoCard = !!card;
      var root = form.closest('[data-amc-po-root]');
      var productCity = '';
      var productState = '';
      if (card) {
        productCity = String(card.getAttribute('data-amc-po-product-city') || '').trim();
        productState = String(card.getAttribute('data-amc-po-product-state') || '').trim();
      }
      if (!productCity && root) {
        productCity = String(root.getAttribute('data-city-name') || '').trim();
        productState = String(root.getAttribute('data-state-name') || '').trim();
      }
      var block = form.closest('.aogen-forms-block');
      var formKey = block ? String(block.getAttribute('data-form-key') || '').trim() : '';
      var hubForm = form.closest('[data-amc-hub-group-form]');
      /* Upper PDP overview group-activity: hide city.
         Hub page section: city visible + editable (prefilled from venue).
         Suggest card: city stays visible for user input. */
      var hideCityField = inPoCard && formKey === 'group-activity' && !hubForm;
      /* AOGEN mounts fields inside [data-aogen-fields], not as form > label. */
      var host =
        form.querySelector('[data-aogen-fields], .aogen-forms-fields') || form;

      if (hubForm) {
        productCity =
          productCity ||
          String(hubForm.getAttribute('data-city') || '').trim() ||
          (card && String(card.getAttribute('data-amc-po-product-city') || '').trim()) ||
          '';
        productState =
          productState ||
          String(hubForm.getAttribute('data-state') || '').trim() ||
          (card && String(card.getAttribute('data-amc-po-product-state') || '').trim()) ||
          '';
      }

      var isSuggestForm = formKey === 'can-t-find-a-workshop-near-you' || formKey.indexOf('can-t-find') !== -1;
      if (block && productCity && !isSuggestForm) {
        try {
          block.setAttribute('data-city', productCity);
          if (productState) block.setAttribute('data-state', productState);
        } catch (e) {}
      }

      var labels = Array.prototype.slice.call(
        host.querySelectorAll(':scope > label, :scope > .aogen-forms-phone-label')
      );
      if (!labels.length) {
        labels = Array.prototype.slice.call(
          form.querySelectorAll('label, .aogen-forms-phone-label')
        );
      }
      labels.forEach(function (lab) {
        lab.removeAttribute('data-amc-po-span');
      });

      var people = null;
      var city = null;
      var emailLab = null;

      labels.forEach(function (lab) {
        var span = lab.querySelector(':scope > span');
        var meta = String(
          (span && span.textContent) || lab.getAttribute('for') || ''
        ).toLowerCase();
        var input = lab.querySelector(
          'input:not([type="hidden"]):not(.aogen-forms-hp), select, textarea, .amc-aogen-phone__national, .aogen-forms-phone-national'
        );
        var named = lab.querySelector(
          'input[name]:not([type="hidden"]), select[name], textarea[name]'
        );
        if (!named) {
          named = lab.querySelector('input[name="city"], input[name="city_2"]');
        }
        var name = named ? String(named.getAttribute('name') || '').toLowerCase() : '';
        if (!name && lab.classList.contains('aogen-forms-phone-label')) name = 'phone';

        /* Only remap labels on PDP overview cards (group / suggest). */
        if (inPoCard && LABELS[name] && span && !lab.hasAttribute('data-amc-po-city-hidden')) {
          span.textContent = LABELS[name];
        }

        if (named && PLACEHOLDERS[name] && named.type !== 'hidden') {
          named.setAttribute('placeholder', PLACEHOLDERS[name]);
        }
        if (input && input.classList && (
          input.classList.contains('amc-aogen-phone__national') ||
          input.classList.contains('aogen-forms-phone-national')
        )) {
          input.setAttribute('placeholder', 'Your phone number');
        }
        if (named && name === 'phone' && named.type !== 'hidden') {
          named.setAttribute('placeholder', 'Your phone number');
        }

        if (name === 'email') emailLab = lab;

        if (
          /how many|people|joining/.test(meta) ||
          name.indexOf('how_many') !== -1 ||
          name.indexOf('people') !== -1
        ) {
          people = lab;
          if (named && named.type !== 'hidden') {
            named.setAttribute(
              'placeholder',
              hubForm ? 'e.g. 12' : PLACEHOLDERS.how_many_people_are_joining
            );
            if (hubForm) {
              named.setAttribute('inputmode', 'numeric');
              named.setAttribute('pattern', '[0-9]*');
            }
          }
        }
        if (
          name === 'city_2' ||
          name === 'city' ||
          (/\bcity\b/.test(meta) && name.indexOf('workshop') === -1)
        ) {
          if (named && name.indexOf('workshop') === -1) {
            /* Hub: keep only the first city label visible (schema often has city + city_2). */
            if (hubForm && city) {
              if (productCity) {
                named.value = productCity;
                named.setAttribute('value', productCity);
              }
              if (named.type !== 'hidden') {
                try {
                  named.type = 'hidden';
                } catch (eHubDup) {}
                named.setAttribute('type', 'hidden');
              }
              lab.setAttribute('data-amc-po-city-hidden', '1');
              lab.setAttribute('data-amc-hub-city-hidden', '1');
              lab.style.setProperty('display', 'none', 'important');
              lab.style.setProperty('height', '0', 'important');
              lab.style.setProperty('margin', '0', 'important');
              lab.style.setProperty('padding', '0', 'important');
              lab.style.setProperty('overflow', 'hidden', 'important');
              lab.setAttribute('aria-hidden', 'true');
            } else if (hubForm) {
              city = lab;
              /* Hub section: show city, prefill from venue, keep editable. */
              if (String(named.getAttribute('type') || '').toLowerCase() === 'hidden') {
                try {
                  named.type = 'text';
                } catch (eHubShow) {}
                named.setAttribute('type', 'text');
              }
              var hubCityUserEdited =
                named.getAttribute('data-amc-hub-city-user-edited') === '1';
              if (productCity && !hubCityUserEdited) {
                named.value = productCity;
                named.setAttribute('value', productCity);
                named.setAttribute('data-amc-po-city-prefilled', '1');
                try {
                  named.dispatchEvent(new Event('input', { bubbles: true }));
                  named.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (eHubPrefill) {}
              }
              named.removeAttribute('readonly');
              named.readOnly = false;
              named.removeAttribute('disabled');
              named.disabled = false;
              named.style.setProperty('pointer-events', 'auto', 'important');
              named.setAttribute('placeholder', PLACEHOLDERS.city || 'City');
              if (named.getAttribute('data-amc-hub-city-edit-bound') !== '1') {
                named.setAttribute('data-amc-hub-city-edit-bound', '1');
                named.addEventListener('input', function () {
                  named.setAttribute('data-amc-hub-city-user-edited', '1');
                });
              }
              lab.removeAttribute('data-amc-po-city-hidden');
              lab.removeAttribute('data-amc-hub-city-hidden');
              lab.style.removeProperty('display');
              lab.style.removeProperty('height');
              lab.style.removeProperty('margin');
              lab.style.removeProperty('padding');
              lab.style.removeProperty('overflow');
              lab.style.setProperty('pointer-events', 'auto', 'important');
              lab.removeAttribute('aria-hidden');
            } else {
            city = lab;
            if (hideCityField || named.type === 'hidden') {
              if (productCity) {
                named.value = productCity;
                named.setAttribute('value', productCity);
                named.setAttribute('data-amc-po-city-prefilled', '1');
                try {
                  named.dispatchEvent(new Event('input', { bubbles: true }));
                  named.dispatchEvent(new Event('change', { bubbles: true }));
                } catch (e2) {}
              }
              if (named.type !== 'hidden') {
                try {
                  named.type = 'hidden';
                } catch (eHide) {}
                named.setAttribute('type', 'hidden');
              }
              lab.setAttribute('data-amc-po-city-hidden', '1');
              lab.style.setProperty('display', 'none', 'important');
              lab.style.setProperty('height', '0', 'important');
              lab.style.setProperty('margin', '0', 'important');
              lab.style.setProperty('padding', '0', 'important');
              lab.style.setProperty('overflow', 'hidden', 'important');
            } else {
              /* Suggest card: visible empty city. */
              if (
                named.hasAttribute('data-amc-po-city-prefilled') ||
                (productCity && String(named.value || '').trim() === productCity)
              ) {
                named.value = '';
                named.removeAttribute('value');
                named.removeAttribute('data-amc-po-city-prefilled');
              }
              named.setAttribute('placeholder', 'Please select...');
              lab.removeAttribute('data-amc-po-city-hidden');
              lab.style.removeProperty('display');
              lab.style.removeProperty('height');
              lab.style.removeProperty('margin');
              lab.style.removeProperty('padding');
              lab.style.removeProperty('overflow');
              if (String(named.getAttribute('type') || '').toLowerCase() === 'hidden') {
                try {
                  named.type = 'text';
                } catch (eShow) {}
                named.setAttribute('type', 'text');
              }
            }
            }
          }
        }
        if (
          name === 'name' ||
          name === 'email' ||
          name === 'phone' ||
          lab.classList.contains('aogen-forms-phone-label') ||
          lab.querySelector('.amc-aogen-phone, .aogen-forms-phone')
        ) {
          lab.setAttribute('data-amc-po-span', 'full');
        }
      });

      if (productCity) {
        form.querySelectorAll('input[type="hidden"][name="city"]').forEach(function (hid) {
          hid.value = productCity;
          hid.setAttribute('value', productCity);
        });
      }

      var isSuggest =
        formKey === 'can-t-find-a-workshop-near-you' || formKey.indexOf('can-t-find') !== -1;

      /* Suggest card: Email | City side-by-side (Figma). */
      if (inPoCard && isSuggest && emailLab && city && !hideCityField) {
        if (emailLab.nextElementSibling !== city) {
          try {
            host.insertBefore(city, emailLab.nextSibling);
          } catch (eSug) {}
        }
        host.setAttribute('data-amc-po-aogen-split', '1');
        form.setAttribute('data-amc-po-aogen-split', '1');
        emailLab.removeAttribute('data-amc-po-span');
        city.removeAttribute('data-amc-po-span');
        emailLab.style.setProperty('grid-column', 'auto', 'important');
        city.style.setProperty('grid-column', 'auto', 'important');
        emailLab.style.setProperty('width', '100%', 'important');
        city.style.setProperty('width', '100%', 'important');
        emailLab.style.setProperty('max-width', '100%', 'important');
        city.style.setProperty('max-width', '100%', 'important');
      } else if (inPoCard && people && city && !hideCityField) {
        /* Group card: People | City when city visible. */
        if (people.nextElementSibling !== city) {
          try {
            host.insertBefore(city, people.nextSibling);
          } catch (e3) {}
        }
        host.setAttribute('data-amc-po-aogen-split', '1');
        form.setAttribute('data-amc-po-aogen-split', '1');
        people.removeAttribute('data-amc-po-span');
        city.removeAttribute('data-amc-po-span');
      } else {
        host.removeAttribute('data-amc-po-aogen-split');
        form.removeAttribute('data-amc-po-aogen-split');
      }

      if (block && formKey === 'group-activity' && (productCity || hubForm)) {
        var ctxRoot = hubForm || form.closest('[data-amc-po-root]');
        function ctxAttr(name) {
          var fromRoot = ctxRoot ? String(ctxRoot.getAttribute(name) || '').trim() : '';
          if (fromRoot) return fromRoot;
          return String(block.getAttribute(name) || '').trim();
        }
        var detail = {
          form_key: 'group-activity',
          intent: 'inline',
          city: productCity,
          state: productState,
          venue_id: ctxAttr('data-venue-id'),
          venue_name: ctxAttr('data-venue-name'),
          workshop_type: ctxAttr('data-workshop-type'),
          country: ctxAttr('data-country') || 'US',
          product_id: ctxAttr('data-product-id'),
          product_name: ctxAttr('data-product-name'),
          product_handle: ctxAttr('data-product-handle')
        };
        try {
          document.dispatchEvent(new CustomEvent('aogen:booking-context', { detail: detail }));
        } catch (e4) {}
      }

      /* Private-event (and others): AOGEN blank option "—" → Please select */
      host.querySelectorAll('select').forEach(function (sel) {
        var opt0 = sel.options && sel.options[0];
        if (!opt0) return;
        var val = String(opt0.value || '').trim();
        var txt = String(opt0.textContent || '').trim();
        if (val === '' && (/^[—–−\-]*$/.test(txt) || txt === '' || txt === '—')) {
          opt0.textContent = 'Please select';
        }
      });
    });
  }

  function processEmbed(embed) {
    if (!embed) return;
    if (embed.shadowRoot) {
      processScope(embed.shadowRoot, embed);
      watchShadow(embed.shadowRoot);
    }
    processScope(embed, embed);
    walkShadows(embed.shadowRoot || embed, processScope, embed);
  }

  function process() {
    if (running) return;
    running = true;
    try {
      document.querySelectorAll(CARD_SEL).forEach(function (card) {
        card.querySelectorAll(EMBED_SEL).forEach(processEmbed);
        card.querySelectorAll('[data-forms-id]').forEach(processEmbed);
        processScope(card, card);
        walkShadows(card, processScope, card);
      });
      processAogenPoForms();
    } finally {
      running = false;
    }
  }

  function schedule() {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(process, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', process);
  } else {
    process();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  [50, 150, 400, 900, 1800, 3500, 7000, 12000].forEach(function (ms) {
    window.setTimeout(process, ms);
  });
})();
